import { Navigate, Outlet, useLocation } from "react-router-dom";

import { Layout } from "@/components/layout";
import StorageManager from "@/features/storage";

const getIsAuthenticated = () => {
  const token = StorageManager.getTokenData();
  if (!token?.access_token || token.requiresPinChange) {
    return false;
  }

  return true;
};

export const PrivateRoutesGuard = () => {
  const isAuthenticated = getIsAuthenticated();
  const location = useLocation();

  return isAuthenticated ? (
    <Layout isAuthenticated={true}>
      <Outlet />
    </Layout>
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
};
